<template>
  <button
    :disabled="disabled"
    :class="[
      `button--${size}`,
      color,
      { 'is-bordered': bordered },
      { 'is-disabled': disabled },
      { 'button--full-width': fluid }
    ]"
    class="button"
    @click="$emit('click')"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "VButton",
  props: {
    bordered: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "blue"
    },
    size: {
      type: String,
      default: "sm"
    },
    text: {
      type: [String, Number],
      default: "text"
    }
  }
};
</script>

<style scoped lang="scss">
.button {
  border-radius: 5px;
  font-weight: 600;
  letter-spacing: 0.03em;
  &:disabled {
    background: $gray-lighter !important;
    color: $gray !important;
  }
  &--full-width {
    width: 100%;
  }
  &--xs {
    font-weight: 500;
    font-size: 14px;
    padding: 7px 10px;
  }
  &--sm {
    padding: 10px 40px;
  }
  &--md {
    padding: 17px 30px;
  }
  &--lg {
    padding: 20px 30px;
    font-size: 18px;
  }
  &.blue {
    background: $blue;
    color: $white;
    &:hover {
      background: darken($blue, 5%);
    }
    &.is-bordered {
      background: transparent;
      color: $blue;
      border: solid 1px $blue;
      &:hover {
        background: $blue-light;
      }
    }
  }
  &.red {
    background: transparent;
    color: $red;
    border: solid 1px $red;
    &:hover {
      background: lighten($red-light, 7%);
    }
  }
}
</style>
